export const extractYearFromExpectedApprovalDate = value => {
  if (!value) return null;

  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return value.getFullYear();
  }

  const valueAsString = String(value).trim();

  if (!valueAsString) return null;

  const isoDateMatch = valueAsString.match(/^(\d{4})-\d{2}-\d{2}/);
  if (isoDateMatch) {
    return parseInt(isoDateMatch[1], 10);
  }

  const slashDateMatch = valueAsString.match(/^\d{1,2}\/\d{1,2}\/(\d{4})$/);
  if (slashDateMatch) {
    return parseInt(slashDateMatch[1], 10);
  }

  const parsedDate = new Date(valueAsString);
  return Number.isNaN(parsedDate.getTime()) ? null : parsedDate.getFullYear();
};

export const normalizePipeline = value => {
  if (value === null || value === undefined) return '';
  return String(value).trim();
};

const isPipelineA = pipelineValue => {
  const normalizedValue = normalizePipeline(pipelineValue).toLowerCase();
  return normalizedValue === 'pipeline a' || normalizedValue === 'a';
};

const isPipelineB = pipelineValue => {
  const normalizedValue = normalizePipeline(pipelineValue).toLowerCase();
  return normalizedValue === 'pipeline b' || normalizedValue === 'b';
};

export const filterProjectsInPreparationByHeader = (projects, selectedPreparationYear = 0, selectedPipelineLabel = '') =>
  projects.filter(project => {
    const matchesYear =
      selectedPreparationYear === 0 || extractYearFromExpectedApprovalDate(project.field7) === selectedPreparationYear;
    const matchesPipeline =
      selectedPipelineLabel === '' || normalizePipeline(project.field6).toLowerCase() === selectedPipelineLabel.toLowerCase();

    return matchesYear && matchesPipeline;
  });

export const getProjectsInPreparationPipelineCounts = projects => {
  return projects.reduce(
    (accumulator, project) => {
      if (isPipelineA(project.field6)) {
        accumulator.pipelineACount += 1;
      }

      if (isPipelineB(project.field6)) {
        accumulator.pipelineBCount += 1;
      }

      return accumulator;
    },
    { pipelineACount: 0, pipelineBCount: 0 },
  );
};
